import { Client, Room } from "colyseus.js";
import { ARENA_ROOM } from "../shared/protocol";
import { playerId } from "./identity";

function wsEndpoint() {
  const proto = location.protocol === "https:" ? "wss" : "ws";
  return `${proto}://${location.host}`;
}

const client = new Client(wsEndpoint());

export async function createRoom(
  name: string,
  opts: { mode?: string; vsBot?: boolean; botLevel?: string } = {},
): Promise<Room> {
  return client.create(ARENA_ROOM, { name, pid: playerId(), ...opts });
}

export async function joinRoom(code: string, name: string): Promise<Room> {
  const res = await fetch(`/api/room/${encodeURIComponent(code.toUpperCase())}`);
  if (!res.ok) {
    throw new Error(res.status === 404 ? "No open room with that code." : "Could not reach server.");
  }
  const { roomId } = await res.json();
  return client.joinById(roomId, { name, pid: playerId() });
}

/** Re-attach to a room after a dropped connection. Token comes from room.reconnectionToken. */
export async function reconnectRoom(token: string): Promise<Room> {
  return client.reconnect(token);
}
